import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageDirective } from './message.directive';

@NgModule({
  declarations: [MessageDirective],
  imports: [CommonModule],
  exports: [MessageDirective],
})
export class MessageModule {}
